/**
 * 带背景的关闭图标
 */
const CloseBgIcon = ({ width = 22, height = 22, color = '#000000', ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill="#E1E1E4"
      />
      <path
        d="M7.75726 6.815L6.81445 7.75781L10.5857 11.529L11.5285 11.529L11.5285 10.5862L7.75726 6.815Z"
        fill={color}
      />
      <path
        d="M6.815 16.2427L7.75781 17.1855L11.529 13.4143L11.529 12.4715L10.5862 12.4715L6.815 16.2427Z"
        fill={color}
      />
      <path
        d="M17.185 16.2427L16.2422 17.1855L12.471 13.4143L12.471 12.4715L13.4138 12.4715L17.185 16.2427Z"
        fill={color}
      />
      <path
        d="M17.185 7.75726L16.2422 6.81445L12.471 10.5857L12.471 11.5285L13.4138 11.5285L17.185 7.75726Z"
        fill={color}
      />
    </svg>
  )
}

export default CloseBgIcon
